var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 0.833313C4.93766 0.833313 0.833496 4.93748 0.833496 9.99998C0.833496 15.0625 4.93766 19.1666 10.0002 19.1666C15.0627 19.1666 19.1668 15.0625 19.1668 9.99998C19.1668 4.93748 15.0627 0.833313 10.0002 0.833313ZM10.8335 13.3333C10.8335 13.5543 10.7457 13.7663 10.5894 13.9226C10.4331 14.0788 10.2212 14.1666 10.0002 14.1666C9.77915 14.1666 9.56719 14.0788 9.41091 13.9226C9.25463 13.7663 9.16683 13.5543 9.16683 13.3333V10.8333H6.66683C6.44582 10.8333 6.23385 10.7455 6.07757 10.5892C5.92129 10.433 5.8335 10.221 5.8335 9.99998C5.8335 9.77897 5.92129 9.56701 6.07757 9.41072C6.23385 9.25444 6.44582 9.16665 6.66683 9.16665H9.16683V6.66665C9.16683 6.44563 9.25463 6.23367 9.41091 6.07739C9.56719 5.92111 9.77915 5.83331 10.0002 5.83331C10.2212 5.83331 10.4331 5.92111 10.5894 6.07739C10.7457 6.23367 10.8335 6.44563 10.8335 6.66665V9.16665H13.3335C13.5545 9.16665 13.7665 9.25444 13.9228 9.41072C14.079 9.56701 14.1668 9.77897 14.1668 9.99998C14.1668 10.221 14.079 10.433 13.9228 10.5892C13.7665 10.7455 13.5545 10.8333 13.3335 10.8333H10.8335V13.3333Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#28A8E0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.93057886e7c719823d7823b9e16b2430.svg";
export { ForwardRef as ReactComponent };